import React, { useContext } from 'react';
import { Context } from 'components/Store';
import PropTypes from 'prop-types';
import { FormikSearchSelect } from 'components/UiKit/FormikFields';
import { useFormikContext } from 'formik';
import stateItems from '../../../../../components/AddressFields/StateSelect/data';

const stateDefaultPropSetStateSelected = () => {};
const State = ({ setStateSelected = stateDefaultPropSetStateSelected }) => {
  const { setFieldValue } = useFormikContext();
  const [{ isEnableInfoTabEdit }] = useContext(Context);

  return (
    <FormikSearchSelect
      label="State"
      name="state"
      items={stateItems}
      placeholder="Select State"
      disabled={!isEnableInfoTabEdit}
      data-testid="ui-field-state"
      onSelect={e => {
        setFieldValue('state', e.key);
        setFieldValue('county', '');
        setStateSelected(true);
      }}
    />
  );
};
State.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  setStateSelected: PropTypes.func
};

export default State;
